import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a3bf838"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "menu-breadcrumbs-item__icon"
}
const _hoisted_2 = {
  key: 3,
  class: "menu-breadcrumbs-item__project-image-wrap"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-breadcrumbs-item__separator"
}

import { computed, inject, onMounted, onUnmounted, PropType, Ref, watch } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmSvg,
} from 'tir-components';
import { FolderIcon, ListBulletIcon } from 'tir-style-system/icons/outline';
import {
  NamespaceModel,
  GroupModel,
  QueueTasksModel,
  SettingsBreadcrumbsModel,
  BreadcrumbProjectModel,
} from '../../models';
import { RouterLink, useRouter } from 'vue-router';
import { MenuBreadcrumbsColorEnum } from '../../enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'menu-breadcrumbs-item',
  props: {
  /**Элемент хлебных крошек */
  breadcrumb: {
    type: Object as PropType<
      BreadcrumbProjectModel | NamespaceModel | GroupModel | QueueTasksModel
    >,
    required: true,
  },
  /**Настройки */
  settings: {
    type: Object as PropType<SettingsBreadcrumbsModel>,
  },
  /**Не использовать роуты */
  noRoute: {
    type: Boolean,
    default: false,
  },
  /**Цвет */
  color: {
    type: String as PropType<MenuBreadcrumbsColorEnum>,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();



/**Текущий роут */
const currentRoute = computed(() => router.currentRoute.value);
/**Элемент неймспейс */
const namespace = computed(() => (props.breadcrumb.isNamespace() ? props.breadcrumb : undefined));
/**Элемент группа */
const group = computed(() => (props.breadcrumb.isGroup() ? props.breadcrumb : undefined));
/**Элемент очередь */
const queue = computed(() => (props.breadcrumb.isQueue() ? props.breadcrumb : undefined));
/**Элемент проекта */
const project = computed(() => (props.breadcrumb.isProject() ? props.breadcrumb : undefined));

/**Есть ли дочерний элемент */
const isHaveChildren = computed(() => {
  if (namespace.value) return !!namespace.value.Group || !!namespace.value.QueueTask;
  if (group.value) return !!group.value.Group || !!group.value.QueueTask;
  return false;
});

/**Выбранны элемент */
const isSelected = computed(() => {
  if (props.settings?.QueueId)
    return (
      queue.value &&
      queue.value.Id === props.settings.QueueId &&
      currentRoute.value.name.toString().match(/kanban|list/g)
    );
  if (props.settings?.GroupId) return group.value && group.value.Id === props.settings.GroupId;
  if (props.settings?.NamespaceId)
    return namespace.value && namespace.value.Id === props.settings.NamespaceId;
  return !!project.value;
});

/**Путь */
const computedRout = computed(() => {
  if (project.value) {
    return { name: 'project', path: '', projectId: props.settings?.ProjectId };
  }
  if (namespace.value) {
    return {
      name: 'namespace',
      params: {
        namespaceId: namespace.value.Id,
        projectId: props.settings?.ProjectId,
      },
    };
  }
  if (group.value) {
    return {
      name: 'group',
      params: {
        groupId: group.value.Id,
        namespaceId: group.value.NamespaceId,
        projectId: props.settings?.ProjectId,
      },
    };
  }
  if (queue.value) {
    return {
      name: 'queue',
      params: {
        queueId: queue.value.Id,
        namespaceId: queue.value.NamespaceId,
        projectId: props.settings?.ProjectId,
      },
    };
  }
});

return (_ctx: any,_cache: any) => {
  const _component_MenuBreadcrumbsItem = _resolveComponent("MenuBreadcrumbsItem", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmButton), {
      variant: _unref(TirPmButtonVariantEnum).LinkState,
      size: _unref(TirPmButtonSizeEnum).Small
    }, {
      default: _withCtx(() => [
        (computedRout.value)
          ? (_openBlock(), _createBlock(_unref(RouterLink), {
              key: 0,
              to: computedRout.value,
              class: _normalizeClass(['menu-breadcrumbs-item', { 'is-selected': isSelected.value, 'no-route': __props.noRoute }])
            }, {
              default: _withCtx(() => [
                (queue.value)
                  ? (_openBlock(), _createBlock(_unref(ListBulletIcon), {
                      key: 0,
                      class: "menu-breadcrumbs-item__icon"
                    }))
                  : (group.value)
                    ? (_openBlock(), _createBlock(_unref(FolderIcon), {
                        key: 1,
                        class: "menu-breadcrumbs-item__icon"
                      }))
                    : (namespace.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createVNode(_unref(TirPmSvg), {
                            url: namespace.value.IconUrl,
                            color: namespace.value.Color,
                            class: "menu-breadcrumbs-item__namespace-icon"
                          }, null, 8, ["url", "color"])
                        ]))
                      : _createCommentVNode("", true),
                (project.value?.Name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_unref(TirPmIconView), {
                        size: 24,
                        isRounded: "",
                        isBordered: false,
                        imageLoadUrl: project.value?.ImageUrl,
                        colorCode: project.value?.PreviewColor
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(_toDisplayString(project.value?.Name[0].toUpperCase()), 1)
                        ]),
                        _: 1
                      }, 8, ["imageLoadUrl", "colorCode"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass([
          'menu-breadcrumbs-item__title',
          {
            'is-selected': isSelected.value,
            'no-route': __props.noRoute,
            'color--gray': __props.color === _unref(MenuBreadcrumbsColorEnum).OnlyGray,
          },
        ])
                }, _toDisplayString(__props.breadcrumb.Name.length >= 30 ? __props.breadcrumb.Name.slice(0, 30) + '...' : __props.breadcrumb.Name), 3)
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["variant", "size"]),
    (isHaveChildren.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "/"))
      : _createCommentVNode("", true),
    (namespace.value?.Group)
      ? (_openBlock(), _createBlock(_component_MenuBreadcrumbsItem, {
          key: 1,
          breadcrumb: namespace.value.Group,
          settings: __props.settings,
          "no-route": __props.noRoute,
          color: __props.color
        }, null, 8, ["breadcrumb", "settings", "no-route", "color"]))
      : (namespace.value?.QueueTask)
        ? (_openBlock(), _createBlock(_component_MenuBreadcrumbsItem, {
            key: 2,
            breadcrumb: namespace.value?.QueueTask,
            settings: __props.settings,
            "no-route": __props.noRoute,
            color: __props.color
          }, null, 8, ["breadcrumb", "settings", "no-route", "color"]))
        : (group.value?.Group)
          ? (_openBlock(), _createBlock(_component_MenuBreadcrumbsItem, {
              key: 3,
              breadcrumb: group.value.Group,
              settings: __props.settings,
              "no-route": __props.noRoute,
              color: __props.color
            }, null, 8, ["breadcrumb", "settings", "no-route", "color"]))
          : (group.value?.QueueTask)
            ? (_openBlock(), _createBlock(_component_MenuBreadcrumbsItem, {
                key: 4,
                breadcrumb: group.value.QueueTask,
                settings: __props.settings,
                "no-route": __props.noRoute,
                color: __props.color
              }, null, 8, ["breadcrumb", "settings", "no-route", "color"]))
            : _createCommentVNode("", true)
  ], 64))
}
}

})